import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["aria-expanded", "aria-controls", "onClick"]
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "trust-center-content" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 1,
  class: "trust-center-tooltip"
}
const _hoisted_8 = { class: "trust-center-tooltip-text" }
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 1,
  class: "secure-donation"
}

import { PartialDisplayType, TrustFAQItemType } from '@/builder/enums';
import { Tooltip } from 'floating-vue';
import { PropType, Ref, computed, inject, onBeforeMount, ref } from 'vue';
import { IPage, PageDesign } from '../page/PageInterface';

//props

export default /*@__PURE__*/_defineComponent({
  __name: 'TrustCenterContainer',
  props: {
    page: {
        type: Object as PropType<IPage>,
        required: true
    },
    builderMode: {
        type: Boolean,
        required: false,
        default: false
    },
    tooltipContainer: {
        type: String,
        required: false,
        default: '.trust-center-container'
    }
},
  setup(__props) {

_useCssVars(_ctx => ({
  "1358d45e": (getTextColor.value),
  "567ad58e": (getBottomPadding.value),
  "b4d21058": (getTopPadding.value)
}))

const props = __props;

//injects
const pageDesign = inject("pageDesign") as Ref<PageDesign>;

//refs
const activeTooltipIndex = ref(-1);
const isMobile = ref(false);
const currentAccordion = ref([]) as any;

//computed
const trustCenter = computed(() => {
    return props.page.trustFAQCenter;
});

const showTrustCenter = computed(() => {
    return props.page.isTrustFAQCenterEnabled && trustCenter.value && trustCenter.value.trustFAQItems.length > 0;
});

const isFormDisplay = computed(() => {
    return props.page.partialDisplayType === PartialDisplayType.Embed && 'form-display';
})

const getTextColor = computed(() => {
    let textColor;

    if (pageDesign.value.trustFaqTextColor) {
        textColor = pageDesign.value.trustFaqTextColor;
    } else if (pageDesign.value.linkColor) {
        textColor = pageDesign.value.linkColor;
    } else {
        textColor = '#A9B0B4';
    }
    return textColor
});

const getBottomPadding = computed(() => {
    return props.page.partialDisplayType === PartialDisplayType.Modal ? '20px' : '0';
});

const getTopPadding = computed(() => {
    return props.page.partialDisplayType === PartialDisplayType.Modal ? '20px' : '40px';
});

const updateIsMobile = () => {
    isMobile.value = window.innerWidth < 768;
};

//methods
const showToolTip = (index: number) => {
    return activeTooltipIndex.value === index;
};

const hoverTooltip = (index: number, show: boolean) => {
    if (show) {
        activeTooltipIndex.value = index;
    } else {
        activeTooltipIndex.value = -1;
    }
};

// Accordion toggling method
const toggleAccordion = (index: any) => {
    if (currentAccordion.value.includes(index)) {
        currentAccordion.value.length == 1 ?
            currentAccordion.value = [] :
            currentAccordion.value.splice(index, 1);
    }
    else {
        currentAccordion.value.push(index);
    }
}

// Accordion animation methods
const beforeEnter = (el) => {
    el.style.height = '0';
};

const enter = (el) => {
    el.style.height = el.scrollHeight + 'px';
};

const beforeLeave = (el) => {
    el.style.height = el.scrollHeight + 'px';
}

const leave = (el) => {
    el.style.height = '0';
}

// Mobile resizing event
window.addEventListener("resize", updateIsMobile);

// onBeforeMount event
onBeforeMount(() => {
    updateIsMobile();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(['trust-center-container', isFormDisplay.value])
  }, [
    (showTrustCenter.value)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trustCenter.value.trustFAQItems, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.id
            }, [
              (isMobile.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (item.type === _unref(TrustFAQItemType).HoverText)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "trust-center-accordion",
                            "aria-expanded": currentAccordion.value.includes(index),
                            "aria-controls": `trustCenterContent${index + 1}`,
                            onClick: ($event: any) => (toggleAccordion(index))
                          }, [
                            (index === 0)
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: _normalizeClass(`fa-solid fa-${trustCenter.value.icon} trust-center-icon`),
                                  "aria-hidden": "true"
                                }, null, 2))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(item.title), 1)
                          ], 8, _hoisted_2),
                          _createVNode(_Transition, {
                            appear: "",
                            onBeforeEnter: beforeEnter,
                            onEnter: enter,
                            onBeforeLeave: beforeLeave,
                            onLeave: leave
                          }, {
                            default: _withCtx(() => [
                              (currentAccordion.value.includes(index))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    id: `trustCenterContent${index + 1}`,
                                    class: "slide-down rd-overflow-hidden"
                                  }, [
                                    _createElementVNode("p", _hoisted_4, _toDisplayString(item.content), 1)
                                  ], 8, _hoisted_3))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          (index === 0)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: _normalizeClass(`fa-solid fa-${trustCenter.value.icon} trust-icon`),
                                "aria-hidden": "true"
                              }, null, 2))
                            : _createCommentVNode("", true),
                          _createElementVNode("a", {
                            href: item.content ?? undefined,
                            target: "_blank",
                            class: "trust-center-item"
                          }, _toDisplayString(item.title), 9, _hoisted_6)
                        ]))
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (index === 0)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: _normalizeClass(`fa-solid fa-${trustCenter.value.icon} trust-center-icon`),
                          "aria-hidden": "true"
                        }, null, 2))
                      : _createCommentVNode("", true),
                    (item.type === _unref(TrustFAQItemType).HoverText)
                      ? (_openBlock(), _createBlock(_unref(Tooltip), {
                          key: 1,
                          distance: "4",
                          triggers: ['hover'],
                          container: __props.tooltipContainer,
                          delay: "15",
                          show: showToolTip(index),
                          onMouseenter: ($event: any) => (hoverTooltip(index, true)),
                          onMouseleave: ($event: any) => (hoverTooltip(index, false)),
                          popperClass: "tooltip-light"
                        }, {
                          popper: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.content), 1)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_8, _toDisplayString(item.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["container", "show", "onMouseenter", "onMouseleave"]))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 2,
                          href: item.content ?? undefined,
                          target: "_blank",
                          class: "trust-center-item"
                        }, _toDisplayString(item.title), 9, _hoisted_9))
                  ]))
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[0] || (_cache[0] = [
          _createElementVNode("i", {
            class: "fa-solid fa-shield-heart secure-donation-icon",
            "aria-hidden": "true"
          }, null, -1),
          _createElementVNode("span", { class: "secure-donation-title" }, "Secure Donation", -1)
        ])))
  ], 2))
}
}

})